import AccountDetailsReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/AccountDetailsReducer";
import ChangeCustomerWarehouseDataReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/ChangeCustomerWarehouseReducer";
import CustomAccountShipToReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/CustomAccountShipToReducer";
import CustomShippingFieldReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/CustomShippingFieldReducer";
import OrderDataReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/OrderHistoryStatus";
import PODDataReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/PODDataReducer";
import QuoteCartReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/QuoteCartReducer";
import ConcreteCalculatorReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/ConcreteCalculatorQuoteCartReducer";
import GuestRFQFormReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/GuestRFQFormReducer";

import { combineReducers } from "redux";
import GuestRFQCartReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/GuestRFQCartReducer";
import OrderHistoryDateRangeValidatorReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/OrderHistoryDateRangeValidatorReducer";
import ProductsReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/ProductsReducer";
import ProductListViewReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/ProductListViewReducer";
import PromotionReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/PromotionReducer";
import PromotionCartReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/PromotionCartReducer";
import ContactUsFormLocationsReducer from "@WhiteCap/Store/Reducer/WhiteCapReducer/ContactUsFormLocationsReducer";

// Define the object containing all custom reducers
const customDataReducerData = {
    // Manages state related to custom shipping fields
    customShippingField: CustomShippingFieldReducer,

    // Manages state for proof of delivery (POD) data
    podDataStore: PODDataReducer,

    // Handles state for changing customer warehouse data
    changeCustomerWarehouseData: ChangeCustomerWarehouseDataReducer,

    // Manages the state for order statuses
    orderStatus: OrderDataReducer,

    // Stores account-related information
    accountInformationStore: AccountDetailsReducer,

    // Handles state for custom account ship-to information
    accountShipToReducer: CustomAccountShipToReducer,

    // Manages the state for the quote cart
    quoteCart: QuoteCartReducer,

    // Handles state related to concrete calculator data
    concreteCalculation: ConcreteCalculatorReducer,

    // Manages guest RFQ (Request for Quote) form data
    GuestRFQForm: GuestRFQFormReducer,

    // Handles state for guest RFQ cart data
    GuestRFQCart: GuestRFQCartReducer,

    // Manages validation for order history date range
    orderHistoryDateRangeValidatorStore: OrderHistoryDateRangeValidatorReducer,

    // Handles state for product grouping
    products: ProductsReducer,

    //Handles Product List Views
    view: ProductListViewReducer,

    // Handles Promotion Products
    promotionProducts: PromotionReducer,

    // Handles Promotion cart products
    promotionCart: PromotionCartReducer,

    //Handles locations in contact us form
    branches: ContactUsFormLocationsReducer,    
};

// Define a type alias for the custom data reducers
export type DataReducers = typeof customDataReducerData;

// Combine all reducers into a single root reducer
// This creates a state tree where each key in `customDataReducerData` becomes a corresponding slice of the state.
const customDataReducer = combineReducers(customDataReducerData as any);

// Export the combined reducer
export default customDataReducer;
